import { Button, makeStyles } from '@material-ui/core';
import { useI18next } from 'gatsby-plugin-react-i18next';
import React, { useCallback } from 'react';
import { Text } from '../../../shared/components/Text';

const useStyle = makeStyles(theme => ({
  button: {
    color: theme.palette.white,
    borderRadius: 0,
    borderColor: theme.palette.white,
    padding: '10px 20px',
  },
}));

export const LangButton = () => {
  const { changeLanguage, i18n } = useI18next();
  const switchToEn = useCallback(() => changeLanguage('en'), []);
  const switchToIt = useCallback(() => changeLanguage('it'), []);

  const switchTranslation = e => {
    if (i18n.language === 'it') {
      switchToEn();
    } else {
      switchToIt();
    }
  };

  const classes = useStyle();
  return (
    <Button
      onClick={switchTranslation}
      variant="outlined"
      className={classes.button}
    >
      <Text variant="h5">{i18n.language === 'it' ? 'EN' : 'IT'}</Text>
    </Button>
  );
};
